export const eduAccFlowHeaderSx = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logoBox: {
    borderRight: "1px solid rgba(128, 128, 128, 0.5)",
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  stepsValue: {
    color: (theme) => theme.palette.primary.main,
  },
  stepsGrid: {
    display: "flex",
    justifyContent: {
      lg: "flex-start",
      sm: "center",
      xs: "center",
    },
    alignItems: "center",
  },
  exitGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
};
